import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { Globals } from "../../../globals";
import { OrdersServices } from "../services";

/**
 * Generated class for the InvoicesListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-kitchen-history',
  templateUrl: 'kitchen-history.html',
})
export class KitchenHistoryPage {

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public ordersServices: OrdersServices) {
    //this.globals.GAtrackView('Kitchen', 'Kitchen history - View', this.globals.restaurant.email, 'View', 'View kitchen history', 'Kitchen', '');

  }

  ionViewWillEnter() {
    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: ''
    });
    loadingPopup.present();
    this.ordersServices.getOrdersShow(this.globals.restaurant_uid);
    this.ordersServices.getOrdersHidden(this.globals.restaurant_uid, this.globals.user_uid);
    loadingPopup.dismiss();
  }

  onBack() {
    this.navCtrl.pop();
  }

  showOrHideOrder(order) {

    if (this.ordersServices.orders_hidden_array) {
      var index = this.ordersServices.orders_hidden_array.findIndex(x => x.order_uid == order.UID);
      if (index >= 0) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }

  }

  changeToShow(order) {
    var index = this.ordersServices.orders_hidden_array.findIndex(x => x.order_uid == order.UID);
    if (index >= 0) {
      this.ordersServices.showOrder(this.ordersServices.orders_hidden_array[index].UID);
    }
  }



}



// WEBPACK FOOTER //
// ./src/pages/kitchen/kitchen-history/kitchen-history.ts